import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import defaultMsg from '../../../translations/lang/en-US.json';

class GiftCardModal extends React.Component {
  render() {
    return (
      <Modal
        show={this.props.status}
        onHide={this.props.closeGiftCardModal}
        animation={true}
        bsSize="small"
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <div className="form-group" style={{ textAlign: 'center' }}>
            <span><FormattedMessage id="existingGiftCard" defaultMessage={defaultMsg.existingGiftCard} /> :</span>
          </div>
          <div className="form-group">
            <input
              type="text"
              className="form-control"
              value={this.props.giftCardData.cardNumber}
              style={{ textAlign: 'center' }}
              disabled
            />
          </div>
          <div className="form-group" style={{ textAlign: 'center' }}>
            <span>
              <FormattedMessage id="balance" defaultMessage={defaultMsg.balance} /> : {this.props.parsePrice(this.props.giftCardData.balance)}
            </span>
          </div>
          <div className="form-group">
            <hr />
          </div>
          <div className="form-group">
            <div className="row">
              <div className="col-md-12" style={{ textAlign: 'center' }}>
                <Button onClick={this.props.handleGiftCardDiscount}>
                <FormattedMessage id="applyDiscount" defaultMessage={defaultMsg.applyDiscount} />
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}
export default GiftCardModal;



// WEBPACK FOOTER //
// ./src/views/checkout/components/GiftCardModal.jsx